
<div class="grid">
	<div class="col-12 flex align-items-center p-3" [class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
		<p-button id="addScenary" label="{{ 'ADD_SCENARIO' | translate }}" (click)="addScenery()" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
				icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>

	<div class="col-12">
		<p-accordion>
			<p-accordionTab *ngFor="let scenery of sceneries">
				<ng-template pTemplate="header">
					<!-- ACTION BUTTONS ON HEADER TAB ALSO ON MOBILE VER -->
					<div class="grid flex align-items-center w-full pt-2 -mb-2">
						<div [class]="!onExtendedMobile() ? 'col-5' : 'col-12 flex justify-content-center'" class="py-0"><span class="font-bold white-space-nowrap">{{scenery.Name}}</span></div>
						<div [class]="!onExtendedMobile() ? 'col-5' : 'col-12 flex justify-content-center'" class="py-0"><span class="font-normal white-space-nowrap">{{scenery.Description}}</span></div>
						<div [class]="!onExtendedMobile() ? 'col-2 flex justify-content-end' : 'col-12 flex justify-content-center'" class="py-0 pr-0"> 
							<!-- <p-button pTooltip="{{ 'ADD_STEP' | translate }}" class="" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
									tooltipPosition="bottom" icon="pi cm-plus" size="large"
									(click)="$event.stopPropagation(); addStep(scenery)" [rounded]="false" [text]="true" severity="primary">
							</p-button> -->
							<p-button pTooltip="{{ 'EXECUTE_SCENARIO' | translate }}" class=""
									tooltipPosition="bottom" icon="pi cm-play-action" size="large"
									(click)="$event.stopPropagation(); executeScenery(scenery)" [rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'EDIT_SCENARIO' | translate }}" class=""
									tooltipPosition="bottom" icon="pi cm-pencil" size="large" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
									(click)="$event.stopPropagation(); editScenery(scenery)" [rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'DELETE_SCENARIO' | translate }}" class=""
									tooltipPosition="bottom" icon="pi cm-trash" size="large" [disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned"
									(click)="$event.stopPropagation(); deleteScenery(scenery)" [rounded]="false" [text]="true" severity="danger">
							</p-button>
						</div>
					</div>
				</ng-template>
				<div>
					<app-scenery [scenery]="scenery" [sceneryStep]="scenerySteps(scenery)"></app-scenery>
				</div>
			</p-accordionTab>
		</p-accordion>
	</div>
</div>

<p-confirmDialog #confDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton
				[label]="confDialog.acceptButtonLabel"
				[ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton
				[label]="confDialog.rejectButtonLabel"
				[ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>
